<div class="min-h-screen bg-white" style="font-family: sans-serif;">

  <!-- Header -->
  <div class="sticky top-0 z-10 bg-white border-b border-gray-200 shadow-sm">
    <div class="max-w-[1200px] mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
      <div class="min-w-0">
        <h1 class="text-base sm:text-lg font-bold text-gray-900" style="font-family: 'Roboto Slab', serif;">Similar Designs</h1>
        <p class="text-[11px] sm:text-xs text-gray-400 truncate mt-0.5">
          Designs similar to <span class="text-[#600b0b] font-medium">{{ wallpaperName }}</span>
        </p>
      </div>
      <button (click)="closeWindow()"
        class="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#600b0b] text-white flex items-center justify-center hover:bg-[#8c1c1c] transition-colors shrink-0 ml-3 shadow-lg"
        title="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="max-w-[1200px] mx-auto px-4 sm:px-6 py-5 sm:py-8">

    <!-- Loading -->
    <div *ngIf="loading" class="flex items-center justify-center" style="min-height: 50vh;">
      <div class="text-center space-y-4">
        <div class="w-10 h-10 border-2 border-[#600b0b] border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p class="text-xs text-gray-400 uppercase tracking-widest font-bold">Finding similar designs...</p>
      </div>
    </div>

    <!-- Empty -->
    <div *ngIf="!loading && similarItems.length === 0" class="flex flex-col items-center justify-center text-center" style="min-height: 50vh;">
      <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="text-gray-300"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      </div>
      <p class="text-base text-gray-500 font-medium mb-2">No similar designs found</p>
      <p class="text-sm text-gray-400 mb-6">Try a different wallpaper.</p>
      <button (click)="closeWindow()" class="bg-[#600b0b] text-white px-8 py-3 rounded-lg text-xs font-bold uppercase tracking-widest hover:bg-[#8c1c1c]">
        Close Window
      </button>
    </div>

    <!-- Results -->
    <div *ngIf="!loading && similarItems.length > 0">
      <p class="text-[10px] sm:text-xs text-gray-400 mb-4 uppercase tracking-wider font-bold">{{ similarItems.length }} designs found</p>

      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
        <div *ngFor="let item of similarItems"
          (click)="openPDP(item)"
          class="group cursor-pointer">

          <!-- Image with hover swap -->
          <div class="relative aspect-[4/3] rounded-lg sm:rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all duration-500 bg-gray-50">
            <img [src]="item.list_thumbnail" [alt]="item.name"
              class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0" />
            <img *ngIf="item.hover_thumbnail" [src]="item.hover_thumbnail" [alt]="item.name"
              class="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            <div class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all"></div>
          </div>

          <!-- Details -->
          <div class="mt-2 sm:mt-3 px-0.5">
            <h4 class="font-bold text-xs sm:text-sm text-gray-900 truncate group-hover:text-[#600b0b] transition-colors">{{ item.name }}</h4>
            <p class="text-[10px] sm:text-xs text-gray-500 mt-0.5 capitalize">{{ item.wallpaper_type }} Design <span class="text-gray-400">({{ item.wallpaper_id }})</span></p>
            <!-- Live "from" rate — the service overrides Solr's indexed one, which
                 is the old per-design snapshot. Whole row hidden rather than zeroed
                 when no surface can be priced. -->
            <div *ngIf="item.price" class="flex items-center mt-1 sm:mt-1.5">
              <span class="text-xs sm:text-sm font-bold text-[#600b0b]">&#8377;{{ item.price | number:'1.2-2' }}</span>
              <span class="text-[8px] sm:text-[10px] text-gray-500 ml-0.5">/sq.ft</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
